/* eslint flowtype/require-valid-file-annotation:0 */

const unpackStartArgs = require('app/common/lib/jsonUnpackUtils').unpackStartArgs;

unpackStartArgs();

// eslint-disable-next-line pinterest/no-referencing-p-properties
require('app/www-unauth/Main').default.start(P.startArgs);
